// Project statuses coming from IFS/PLINI
// Added in lower case for convenience
// See readme for explanations
export enum ProjectStatus {
  None = '',
  Initialized = 'initialized',
  Approved = 'approved',
  Started = 'started',
  Completed = 'completed',
  Closed = 'closed',
  Cancelled = 'cancelled'
}


